import React from "react";
import SeoTable from "./components/SeoTable";

function SubcategorySeoTable() {
  return <SeoTable entityType="subcategory" />;
}

export default SubcategorySeoTable;
